/** One identity per document, shared by automatic analytics and OTLP signals. */
export const frontendInstanceId = crypto.randomUUID();
